const prefix = 'features/blockchain-101';

export const BLOCKCHAIN_101 = `${prefix}/BLOCKCHAIN_101`;



// WEBPACK FOOTER //
// ./src/store/features/blockchain-101/action-types.js